// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import Enums from '../Enums';

export class DispatchCustomerMatchInfo {
  readonly address: string | null;
  readonly matchStrength: string;
  readonly dispatchCustomerId: string;
  readonly dispatchCustomerName: string;
  readonly integrationId: string;
  readonly integrationName: string;
  readonly integrationType: Enums.IntegrationType;

  constructor(data: { [key: string]: any } = {}) {
    this.address = data.address === undefined ? null : data.address;
    this.matchStrength = data.matchStrength === undefined ? '0' : data.matchStrength;
    this.dispatchCustomerId =
      data.dispatchCustomerId === undefined ? NIL_UUID : data.dispatchCustomerId;
    this.dispatchCustomerName =
      data.dispatchCustomerName === undefined ? '' : data.dispatchCustomerName;
    this.integrationId = data.integrationId === undefined ? NIL_UUID : data.integrationId;
    this.integrationName = data.integrationName === undefined ? '' : data.integrationName;
    this.integrationType =
      data.integrationType === undefined ? Enums.IntegrationType.Series : data.integrationType;
  }

  static zero(): DispatchCustomerMatchInfo {
    const zeroValues: ExcludeMethodsDeep<DispatchCustomerMatchInfo> = {
      address: null,
      matchStrength: '0',
      dispatchCustomerId: NIL_UUID,
      dispatchCustomerName: '',
      integrationId: NIL_UUID,
      integrationName: '',
      integrationType: Enums.IntegrationType.Series,
    };
    return new DispatchCustomerMatchInfo(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type DispatchCustomerMatchInfoWireFormat = {
  address: string | null;
  matchStrength: string;
  dispatchCustomerId: string;
  dispatchCustomerName: string;
  integrationId: string;
  integrationName: string;
  integrationType: string;
};

type NewDispatchCustomerMatchInfoProps = PartialDeep<
  DispatchCustomerMatchInfo,
  { recurseIntoArrays: true }
>;
export const NewDispatchCustomerMatchInfo: (
  props: NewDispatchCustomerMatchInfoProps,
) => DispatchCustomerMatchInfo = (props) => new DispatchCustomerMatchInfo(props);

type NewDispatchCustomerMatchInfoFromWireFormatProps = PartialDeep<
  DispatchCustomerMatchInfoWireFormat,
  { recurseIntoArrays: true }
>;
export const NewDispatchCustomerMatchInfoFromWireFormat: (
  props: NewDispatchCustomerMatchInfoFromWireFormatProps,
) => DispatchCustomerMatchInfo = (props) => new DispatchCustomerMatchInfo(props);
